import { GET_BULK_WEIGHT_DISCREPANCY_DATA_SUCCESS, GET_BULK_WEIGHT_DISCREPANCY_DATA_REQUEST, GET_BULK_WEIGHT_DISCREPANCY_DATA_FAILURE, GET_BULK_WEIGHT_DISCREPANCY_DATA_RESET, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getBulkWeightDiscrepancyDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BULK_WEIGHT_DISCREPANCY_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_BULK_WEIGHT_DISCREPANCY_DATA_REQUEST:
            return Object.assign({}, state);
        case GET_BULK_WEIGHT_DISCREPANCY_DATA_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case GET_BULK_WEIGHT_DISCREPANCY_DATA_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getBulkWeightDiscrepancyDataReducer;
